const hasValueClassName = 'form-item--has-value';

function formItem(elements) {
    $(elements).each((i, el) => {
        const $elements = $(el).find('input, textarea');
        const $body = $('body');

        $body.on('focus', 'input, textarea', (e) => {
            $(e.currentTarget).closest('.form-item').addClass('is-in-focus');
        });

        $body.on('blur', 'input, textarea', (e) => {
            $(e.currentTarget).closest('.form-item').removeClass('is-in-focus');
        });

        $elements.each((i, el) => {
            const $el = $(el);

            if ($el.val()) {
                $el.closest('.form-item').addClass(hasValueClassName);
            } else if ($el.is(':focus')) {
                $el.closest('.form-item').addClass('is-in-focus');
            }

            $body.on('change input', $elements, handleValue);
        });

        $('[data-checkbox]').on('click', function (e) {
            if ($(this).find('input').is(':checked')) {
                $('[data-checkbox-hide]').addClass('hidden-by-checkbox');
            } else {
                $('[data-checkbox-hide]').removeClass('hidden-by-checkbox');
            }
            e.stopPropagation();
        });

        function handleValue (event) {
            const $this = $(event.target);
            const value = $this.val();
            if (typeof value === 'string' && value.length) {
                $this.closest('.form-item').addClass(hasValueClassName);
            } else {
                $this.closest('.form-item').removeClass(hasValueClassName);
            }
        }
    });
}

export default function (elements) {
    formItem(elements);
}